module.exports = __webpack_public_path__ + "static/img/screenshot.3364844.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/solutions/actualmeasurement/screenshot.png
// module id = YnsO
// module chunks = 12